/**
 * Form validation helper'ları
 * Hepsi boş string -> null (geçerli) veya string -> hata mesajı döner.
 */

export const required = (value: string, label = 'Bu alan'): string | null => {
  if (!value || value.trim().length === 0) return `${label} zorunludur`;
  return null;
};

export const email = (value: string): string | null => {
  if (!value) return null;
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(value)) return 'Geçerli bir e-posta adresi girin';
  return null;
};

export const phone = (value: string): string | null => {
  if (!value) return null;
  // Türkiye telefon: 10-11 hane (0 ile veya 0 olmadan)
  const cleaned = value.replace(/\s|-|\(|\)|\+/g, '');
  if (cleaned.length < 10) return 'Telefon numarası eksik';
  if (cleaned.length > 13) return 'Telefon numarası çok uzun';
  if (!/^\d+$/.test(cleaned)) return 'Sadece rakam kullanın';
  return null;
};

export const minLength = (min: number) => (value: string): string | null => {
  if (!value) return null;
  if (value.length < min) return `En az ${min} karakter olmalı`;
  return null;
};

export const maxLength = (max: number) => (value: string): string | null => {
  if (!value) return null;
  if (value.length > max) return `En fazla ${max} karakter olabilir`;
  return null;
};

export const numeric = (value: string): string | null => {
  if (!value) return null;
  if (isNaN(Number(value))) return 'Sayısal değer girin';
  return null;
};

export const positive = (value: string): string | null => {
  if (!value) return null;
  const n = Number(value);
  if (isNaN(n) || n <= 0) return 'Pozitif bir sayı girin';
  return null;
};

export const minValue = (min: number) => (value: string): string | null => {
  if (!value) return null;
  const n = Number(value);
  if (isNaN(n) || n < min) return `En az ${min} olmalı`;
  return null;
};

export const maxValue = (max: number) => (value: string): string | null => {
  if (!value) return null;
  const n = Number(value);
  if (isNaN(n) || n > max) return `En fazla ${max} olabilir`;
  return null;
};

/**
 * Birden fazla validator'ı zincir et.
 * İlk hata mesajını döndürür.
 */
export const compose = (...validators: Array<(value: string) => string | null>) =>
  (value: string): string | null => {
    for (const v of validators) {
      const err = v(value);
      if (err) return err;
    }
    return null;
  };
